import { FaSpinner } from "react-icons/fa6";

interface LoaderProps {
  /** Optional label shown next to the spinner. */
  text?: string;
  /** Extra classes for the container (e.g. spacing, border, height). */
  className?: string;
  /** Tailwind size classes for the spinner. */
  size?: string;
}

export default function Loader({
  text,
  className = "",
  size = "h-5 w-5",
}: LoaderProps) {
  return (
    <div className={`flex items-center justify-center gap-3 ${className}`}>
      <FaSpinner className={`${size} animate-spin text-primary`} />
      {text && <span className="text-sm text-gray-600">{text}</span>}
    </div>
  );
}
